<template>
	<div class="vue-video" v-if="src">
		<video-aplayer class="video-player vjs-custom-skin" ref="videoPlayer" :options="options" @play="onPlayerPlay" @pause="onPlayerPause" @ended="onPlayerEnded" @timeupdate="onPlayerTimeupdate"></video-aplayer>
	</div>
</template>

<script>
	import 'vue-video-player/node_modules/video.js/dist/video-js.css'
	import 'vue-video-player/src/custom-theme.css'
	import { videoPlayer } from 'vue-video-player'
    // import 'video.js/dist/video-js.css'
	export default {
		name: 'vue-video',
		props: {
			src: {
				type: String,
				default: './rowingsamplevideo.mp4'
				// default: 'https://panvr.xitohere.com/xito/static/media/rowingsamplevideo.09906aa1.mp4'
			},
			breakpoint: {
				type: Number,
				default: -1
			}
		},
		data() {
			const src = this.src;
			return {
				isPlay: false,
				options: {
					playbackRates: [ 0.5, 1.0, 1.5, 2.0 ], //播放速度
					autoplay: false, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4",
						src: src
					}],
					// poster:require('../../../../assets/image/music.png'), //你的封面地址
					// width: document.documentElement.clientWidth, //播放器宽度
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true  //全屏按钮
					}
				}
			}
		},
		watch: {
			breakpoint() {
				// 继续播放
				this.player.play();
			}
		},
		methods: {
			onPlayerPlay(event) {
				this.isPlay = true;
			},
			onPlayerPause(event) {
				this.isPlay = false;
			},
			onPlayerEnded(event) {
				this.isPlay = false;
			},
			onPlayerTimeupdate(event) {
				const currentTime = event.currentTime();
				// 触发断点
				if (this.breakpoint && this.breakpoint > 0 && currentTime > this.breakpoint) {
					if (this.isPlay) {
						this.isPlay = false;
						this.player.pause();
						this.$emit('break-play', currentTime);
					}
				}
			}
		},
		computed: {
			player() {
				return this.src && this.$refs.videoPlayer.player;
			}
		},
		components: {
			'video-aplayer': videoPlayer
		}
	}
</script>

<style>
	.video-js .vjs-icon-placeholder{
	    width: 100%;
	    height: 100%;
	    display: block;
	}
</style>
<style scoped lang="less">
	.vue-video{
		width: 100%;
	}
</style>
